import React from "react";


const Header: React.FC = () => {

  const env: string = import.meta.env.REACT_APP_UI_ENV;
  const nonProdHeader = env !== 'Prod';

  return <header>
    <nav className="navbar navbar-expand-lg navbar-light scrolling-navbar header-height header-margin">
      <div>
        <div className="navbar-brand">
          <div className="header-brand">
            <img className="d-none d-md-inline header-logo"
              src="/images/stonex-hedge.svg"
              alt="StoneX Hedge"
            />
            {nonProdHeader && <div className="d-none d-md-inline header-site-name">{env}</div>}
          </div>
        </div>
      </div>
      <div className="order-xs-3 order-md-1">
        <ul className="nav navbar-nav ml-auto icons-right">
          <li><a href="/">Back to Main Site</a></li>
        </ul>
      </div>
      <div className="collapse navbar-collapse order-xs-2" id="navbarSupportedContent">
      </div>
    </nav>
  </header>;
};

export default Header;